import { Link } from 'react-router-dom';

const services = [
  { icon: 'ri-water-flash-line', label: 'Pumps & Motors' },
  { icon: 'ri-filter-3-line', label: 'Filters' },
  { icon: 'ri-drop-line', label: 'Water Treatment' },
  { icon: 'ri-fire-line', label: 'Heaters' },
  { icon: 'ri-search-eye-line', label: 'Leak Detection' },
  { icon: 'ri-paint-brush-line', label: 'Renovations' },
];

export default function ServicesPreview() {
  return (
    <section className="bg-light-cyan py-20 md:py-24 relative overflow-hidden">
      {/* Decorative Wave */}
      <div className="absolute top-0 right-0 w-64 h-64 opacity-5">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 50 Q 25 30, 50 50 T 100 50 T 150 50 T 200 50" stroke="currentColor" fill="none" strokeWidth="4" className="text-tropical-teal" />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center mb-12">
          <div className="text-tropical-teal text-sm font-semibold uppercase tracking-wider mb-2">
            Our Services
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group cursor-pointer"
              style={{ boxShadow: '0 4px 12px rgba(77, 208, 225, 0.15)' }}
            >
              <div className="flex flex-col items-center text-center">
                <div className="w-14 h-14 flex items-center justify-center mb-4">
                  <i className={`${service.icon} text-5xl text-tropical-teal group-hover:text-coral-pink transition-colors duration-300`}></i>
                </div>
                <h3 className="text-xl font-bold text-charcoal">{service.label}</h3>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/services"
            className="inline-flex items-center gap-2 bg-white text-tropical-teal border-2 border-tropical-teal px-8 py-3.5 rounded-full font-semibold text-base hover:bg-tropical-teal hover:text-white transition-all hover:scale-105 active:scale-95 whitespace-nowrap cursor-pointer"
          >
            See All Services
            <i className="ri-arrow-right-line text-lg"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}